let sensors;

export const sensorEventTypes = {
  VIEW_INFO: 'viewInfo',
  PAGE_VIEW: 'pageViewTrack',
  MARKET_ACTIVITY_CLICK: 'market_activity_click',
  THEME_SWITCH: 'theme_switch',
  GOOGLE_TRANSLATOR_DOWN: 'google_translator_down',
  VIEW_TRADE_FEE_DETAIL: 'view_trade_fee_detail',
  VIEW_MORE_MARKET_ACTIVITY: 'view_more_market_activity',
  CHART_CHANGE: 'chart_change',
  ACCOUNT_MANAGEMENT_TAB: 'accountManagementTab',
  ASSET_MANAGEMENT_TAB: 'assetManagementTab',
  ORDERS_MANAGEMENT_TAB: 'ordersManagementTab',
  TRANSFER_HISTORY_TAB: 'transferHistoryTab',
  LOGIN_HISTORY_TAB: 'loginHistoryTab',
  VIEW_ASSET_DETAIL: 'viewAssetDetail',
  OPEN_ORDER_TAB: 'openOrdersTab',
  ORDER_HISTORY_TAB: 'orderHistoryTab',
  TRADE_HISTORY_TAB: 'tradeHistoryTab',
  SX_FIAT_SELETE: 'quotearea_dropdown_fiatdefault',
  SX_CRYPTO_SELETE: 'quotearea_dropdown_cryptodefault',
  SX_CLICKQUOTE_BUYNOW: 'quotearea_button_buynow',
  SX_CLICKQUOTE_NEXT: 'quotearea_popup_button_gotopayment',
  SX_PAGEVIEW_QUOTE: 'SX_PageviewQuote',
  SWITCH_FIAT_RATE: 'switchFiatRate',
  HOMEPAGE_PAIR_SEARCH: 'homepagePairSearch',
  HOMEPAGE_MARKET_FULLSCREEN: 'homepageMarketFullscreen',
  SWITCH_TAB: 'switchTab',
  LENDING_SUBSCRIBE: 'lendingSubscribe',
  LENDING_SUBSCRIBE_SUBMIT: 'lendingSubscribeSubmit',
  LENDING_SUBSCRIBE_RESULT: 'lendingSubscribeResult',
};

export const setSensors = data => {
  sensors = data;
};

export const getSensors = () => sensors;

export const track = (event, data) => {
  if (sensors) {
    sensors.track(event, data);
  }
};

export const login = userId => {
  if (sensors) {
    sensors.login(userId);
  }
};

export const fixSensorUrl = () => {
  if (sensors) {
    sensors.registerPage({
      '$url': window.location.href,
      '$url_path': window.location.pathname,
    });
  }
};
